import { render } from "./CouponArea.vue?vue&type=template&id=8e84e450"
import script from "./CouponArea.vue?vue&type=script&lang=js"
export * from "./CouponArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__